import { Col, DatePicker, Form, Input, message, Modal, Row, Select, Switch, Upload } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { getAllExpense, getAllExpenseType, getExpenseByID, updateExpense } from "../../utils/API";

interface EditExpenseProps {
    visible: boolean;
    id: string;
    onClose?: () => void;
    onCancel?: () => void;
    onTaskCreated: () => void;
    onSuccess?: () => void;
    // record?: ExpenseFormValues | null;
}

interface ExpenseFormValues {
    _id: string;
    [key: string]: any;
    name: string;
    date: string;
    amount: number;
    expense: string;
    expense_type: string;
    description: string;
    authorize: boolean;
}

const AddExpenseModel: React.FC<EditExpenseProps> = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [form] = Form.useForm();
    const [expense, setExpense] = useState<any>(null);
    const [types, setTypes] = useState<any>([]);

    // useEffect(() => {
    //     if (record) {
    //         form.setFieldsValue({
    //             ...record,
    //             date: record?.date ? dayjs(record?.date, "DD/MM/YYYY") : null,
    //         });
    //     } else {
    //         form.resetFields();
    //     }
    // }, [record, form]);

    const onFinish = async (values: ExpenseFormValues) => {
        setIsLoading(true);
        try {
            const formData = new FormData();

            if (values.date) {
                values.date = dayjs(values.date).format('DD-MM-YYYY'); // Change format as needed
            }

            if (values.authorize === undefined) {
                values.authorize = false;  // Default value in case it's undefined
            }

            const finalValues = {
                ...values,
            };

            if (props.id) {
                await updateExpense(props.id, finalValues);
                message.success("Expense updated successfully!");
            }
            getAllExpense("");
            props.onSuccess?.();
        } catch (error) {
            console.error('Error submitting Expense:', error);
            message.error('Failed to submit Expense. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (expense) {
            form.setFieldsValue({
                name: expense.name,
                date: expense.date ? dayjs(expense.date, "DD-MM-YYYY") : null,
                amount: expense.amount,
                expense: expense.expense,
                company: expense.company,
                expense_type: expense.expense_type,
                description: expense.description,
                authorize: expense.authorize,
            });
        }
    }, [expense, form]);

    const fetchExpense = async () => {
        setIsLoading(true);
        try {
            if (props.id) {
                const data = await getExpenseByID(props.id);
                setExpense(data);
            }
        } catch (error) {
            message.error("Failed to fetch expense data.");
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        fetchExpense();
    }, [props.id]);

    useEffect(() => {
        const fetchTypes = async () => {
            setIsLoading(true);
            try {
                const response: any = await getAllExpenseType();
                console.log("Types:", response);
                if (response?.expenseType) {
                    setTypes(response.expenseType);
                }
            } catch (error) {
                console.error("Error fetching expense type:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchTypes();
    }, []);

    return (
        <Modal
            open={props.visible}
            onCancel={props.onClose}
            footer={null}
            width={800}
            centered={true}
            destroyOnClose
            className="custom-modal"
            bodyStyle={{
                overflowY: "auto",
                fontFamily: "inter, sans-serif",
            }}
            style={{
                bottom: 20,
                top: 20,
                // maxHeight: 'calc(100vh - 30px)',
                margin: '0 auto',
                position: 'relative',
            }}
            styles={{
                header: {
                    padding: "12px",
                    position: "sticky",
                    top: 0,
                    backgroundColor: "#f1f5ffff",
                },
                content: {
                    padding: 0,
                    overflow: "hidden",
                },
            }}
            title={
                <div
                    style={{
                        color: "#4b5563",
                        fontFamily: "inter, sans-serif",
                        fontSize: "20px",
                        fontWeight: 500,
                    }}
                >
                    Edit Expense
                </div>
            }
        >
            <Form onFinish={onFinish} form={form} layout="horizontal"
                labelCol={{ span: 5 }}
                wrapperCol={{ span: 19 }}
                colon={false} style={{ margin: 0 }}>
                <div className="elements">
                    <Form.Item
                        label={
                            <span style={{
                                color: '#4b5563',
                                fontFamily: 'inter, sans-serif',
                                fontSize: '14px',
                                paddingLeft: "15px",
                                fontWeight: 500,
                            }}>
                                Full Name <span className="text-red-500">*</span>
                            </span>
                        }
                        name="name"
                        required={false}
                        rules={[{ required: true, message: "Please enter the name" }]}
                    >
                        <Input placeholder="Fullname" className="Allinput" />
                    </Form.Item>

                    <Form.Item
                        label={
                            <span style={{
                                color: '#4b5563',
                                fontFamily: 'inter, sans-serif',
                                fontSize: '14px',
                                paddingLeft: "15px",
                                fontWeight: 500,
                            }}>
                                Date
                            </span>
                        }
                        name="date"
                        required={false}
                    >
                        <DatePicker className="Allinput" format="DD-MM-YYYY" style={{ width: '100%' }} />
                    </Form.Item>

                    <Form.Item
                        label={
                            <span style={{
                                color: '#4b5563',
                                fontFamily: 'inter, sans-serif',
                                fontSize: '14px',
                                paddingLeft: "15px",
                                fontWeight: 500,
                            }}>
                                Amount
                            </span>
                        }
                        name="amount"
                        required={false}
                    >
                        <Input placeholder="Amount" className="Allinput" />
                    </Form.Item>

                    <Form.Item
                        name="expense"
                        label={
                            <span style={{
                                color: '#4b5563',
                                fontFamily: 'inter, sans-serif',
                                fontSize: '14px',
                                paddingLeft: "15px",
                                fontWeight: 500,
                            }}>
                                Expense
                            </span>
                        }
                        required={false}
                    >
                        <Select
                            placeholder="Select Mode of Expense"
                            className="CustomSelect"
                            showSearch
                            optionFilterProp="children"
                            // value={position}
                            onChange={(value) => {
                                // setPosition(value);
                                form.setFieldsValue({ technology: undefined });
                            }}
                        >
                            <Select.Option value="Bank">Bank</Select.Option>
                            <Select.Option value="Cash">Cash</Select.Option>
                        </Select>
                    </Form.Item>

                    <Form.Item
                        name="expense_type"
                        label={
                            <span style={{
                                color: '#4b5563',
                                fontFamily: 'inter, sans-serif',
                                fontSize: '14px',
                                paddingLeft: "15px",
                                fontWeight: 500,
                            }}>
                                Expense Type
                            </span>
                        }
                        required={false}
                    >
                        <Select
                            placeholder="Select Expense Type"
                            className="CustomSelect"
                            showSearch
                            optionFilterProp="children"
                            // value={position}
                            onChange={(value) => {
                                // setPosition(value);
                                form.setFieldsValue({ technology: undefined });
                            }}
                        >
                            {types.map((type: any) => (
                                <Select.Option key={type._id} value={type.expense_type}>
                                    {type.expense_type}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        name="authorize"
                        required={false}
                        label={
                            <span style={{
                                color: '#4b5563',
                                fontFamily: 'inter, sans-serif',
                                fontSize: '14px',
                                paddingLeft: "15px",
                                fontWeight: 500,
                            }}>
                                Authorized?
                            </span>
                        }
                        valuePropName="checked"
                    >
                        <Switch checkedChildren="Yes" unCheckedChildren="No" />
                    </Form.Item>

                    <Form.Item
                        label={
                            <span style={{
                                color: '#4b5563',
                                fontFamily: 'inter, sans-serif',
                                fontSize: '14px',
                                paddingLeft: "15px",
                                fontWeight: 500,
                            }}>
                                Description
                            </span>
                        }
                        name="description"
                        required={false}
                    >
                        <Input.TextArea
                            placeholder="Enter description"
                            className="Allinputtextarea"
                        />
                    </Form.Item>
                </div>
                <Row justify="end">
                    <Col
                        xs={24}
                        sm={24}
                        md={24}
                        xl={24}
                        xxl={20}
                        className="d-flex justify-content-end me-4"
                    >
                        <div className="button-wrapper">
                            <button
                                className="allcanclebutton"
                                onClick={props.onClose}
                                type="button"
                                disabled={isLoading}
                            >
                                Cancel
                            </button>
                            <button
                                className="allsubmitebutton w-20"
                                type="submit"
                                disabled={isLoading}
                            >
                                {isLoading ? 'Updating...' : 'Update'}
                            </button>
                        </div>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
};

export default AddExpenseModel;